export const HOME_FETCH = "HOME_FETCH";
export const HOME_FETCH_SUCCESS = "HOME_FETCH_SUCCESS";
export const HOME_FETCH_NEXT = "HOME_FETCH_NEXT";
export const HOME_FETCH_NEXT_SUCCESS = "HOME_FETCH_NEXT_SUCCESS";
export const HOME_RESET = "HOME_RESET";
